module.exports = __webpack_public_path__ + "static/media/270325.648623c3.png";